import { Image, Container } from "semantic-ui-react";
const ExpiredPage = () => {
  return (
    <>
      <div className="page thank">
        <div className="page-inner">
          <Container>
            <div className="content">
              <Image
                src={`${process.env.PUBLIC_URL}/images/yayyyy.png`}
                alt="thanh cong"
                style={{ filter: "grayscale(1)" }}
              />
              <p className="title">Sự kiện đã kết thúc</p>

              <div className="body">
                <p>Cảm ơn bạn đã đến và tham gia chương trình và sự kiện.</p>

                <p>
                  Chương trình áp dụng cho{" "}
                  <strong>KHÁCH HÀNG LẦN ĐẦU ĐĂNG KÝ GALAXY PLAY</strong> (Khách
                  hàng chưa từng có gói Cao Cấp và Siêu Việt) Vào Galaxy Play và
                  khám phá kho phim hấp dẫn ngay.
                </p>
              </div>

              <div className="footer">
                <a
                  href="https://galaxyplay.vn/lobby"
                  className="button primary-button"
                  target="_blank"
                >
                  Xem phim ngay
                </a>
              </div>
            </div>
          </Container>
        </div>
      </div>
    </>
  );
};
export default ExpiredPage;
